module.exports = __webpack_public_path__ + "static/media/cloudIcon.2e76d789.svg";